<template>
  <vs-popup class="add-shipping-cost" id="popup" :title="isCreateMode ? 'ADD DEFAULT SHIPPING COST' : 'UPDATE DEFAULT SHIPPING COST'"
    @close="open = false" :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-shipping-cost-popup" @submit.prevent="handleSubmit(onClickCreateCost)" autocomplete="off">

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="cost" name="cost" rules="required" v-slot="{ errors }">
                <small class="label">Cost (GBP/KG)</small>
                <vs-input v-model="form.cost" name="cost" class="w-full" label="" :danger="!!errors[0]"
                  :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="formulation_type" name="formulation_type" rules="required" v-slot="{ errors }">
                <small class="label">Formulation Type</small>
                <v-select name="type" :closeOnSelect="true" v-model="form.formulation_type"
                  :options="formulationTypes" :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="region" name="region" rules="required" v-slot="{ errors }">
                <small class="label">Region</small>
                <v-select name="region" :closeOnSelect="true" v-model="selectedRegion" label="name"
                  :options="regions" :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                <small class="label">Note</small>
                <vs-textarea class="mb-0" v-model="form.note" height="150px" />
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-shipping-costs-setting'" button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="resetForm" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const ShippingCostRepository = RepositoryFactory.get('shipping_cost');
const RegionsRepository = RepositoryFactory.get('regions');
import vSelect from 'vue-select'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    id: '',
    regions: [],
    selectedRegion: null,
    form: {
      cost: '',
      formulation_type: '',
      region_id: null,
      note: ''
    },
    isCreateMode: true
  }
}

export default {
  name: 'AddNewShippingCostPopUp',
  data() {
    return initialState()
  },
  computed: {
    formulationTypes() {
      const baseTypes = ['powder', 'liquid', 'spray dry powder', 'fruit'];
      if (this.form.formulation_type && !baseTypes.includes(this.form.formulation_type)) {
        return [...baseTypes, this.form.formulation_type];
      }
      return baseTypes;
    }
  },
  components: {
    'v-select': vSelect,
  },
  methods: {
    resetForm() {
      this.form.cost = '';
      this.form.note = '';
    },
    async openPopup(id, fg_type, region) {
      try {
        Object.assign(this.$data, initialState());
        this.$refs.form.reset();
        this.open = true;

        const regionsRes = await RegionsRepository.fetchRegionsWithoutPagination();
        this.regions = regionsRes.data.data || regionsRes.data || [];

        if (!!id) {
          this.id = id;
          this.isCreateMode = false;
          await this.fetchShippingCost();
        } else {
          this.form.formulation_type = fg_type ? fg_type.toLowerCase() : '';
          const regionObj = typeof region === 'object' && region !== null
            ? region
            : (this.regions.find(r => r.id === region || r.name === region) || { id: region, name: region });

          this.selectedRegion = regionObj;
          this.form.region_id = regionObj ? regionObj.id : null;
          this.isCreateMode = true;
        }
      } catch (error) {
        this.convertAndNotifyError(error);
      }
    },
    async fetchShippingCost() {
      await this.$vs.loading({
        container: '#create-shipping-cost-popup',
        scale: 0.45
      })
      try {
        const { data } = (await ShippingCostRepository.getShippingCost(this.id)).data;
        this.form.cost = data.cost;
        this.form.formulation_type = data.formulation_type ? data.formulation_type.toLowerCase() : '';
        this.form.note = data.note || '';

        if (data.region && typeof data.region === 'object') {
          this.selectedRegion = data.region;
          this.form.region_id = data.region.id;
        } else if (data.region_id) {
          this.form.region_id = data.region_id;
          this.selectedRegion = this.regions.find(r => r.id === data.region_id) || { id: data.region_id, name: '' };
        } else if (data.region) {
          this.selectedRegion = this.regions.find(r => r.name === data.region) || { id: null, name: data.region };
          this.form.region_id = this.selectedRegion ? this.selectedRegion.id : null;
        }
      } catch (e) {
        this.convertAndNotifyError(e);
      }
      this.$vs.loading.close('#create-shipping-cost-popup > .con-vs-loading');
    },
    async onClickCreateCost() {
      const vue = this;
      await this.$vs.loading({
        container: '#create-shipping-cost-popup',
        scale: 0.45
      })
      try {
        const payload = {
          formulation_type: this.form.formulation_type ? this.form.formulation_type.toLowerCase() : '',
          region_id: this.form.region_id || (this.selectedRegion ? this.selectedRegion.id : null),
          cost: Number(this.form.cost).toFixed(2),
          note: this.form.note || ''
        };

        if (this.isCreateMode) {
          await ShippingCostRepository.createShippingCost(payload);
          this.showSuccessMessage('Shipping cost added!');
        } else {
          await ShippingCostRepository.updateShippingCost(this.id, payload);
          this.showSuccessMessage('Shipping cost updated!');
        }
        await vue.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.$vs.loading.close('#create-shipping-cost-popup > .con-vs-loading');
        this.convertAndNotifyError(e);
      }
      this.$vs.loading.close('#create-shipping-cost-popup > .con-vs-loading');
    },
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.add-shipping-cost>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 30% !important;
}
</style>
